var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "142.318pt",
    height: "133.248pt",
    viewBox: "1470.69 -590.824 142.318 133.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1539.5,525.663 L 1539.5,530.956 C 1536.46,531.008 1533.32,531.952 1531.48,533.262 L 1532.74,536.773 C 1534.63,535.515 1537.35,534.52 1540.29,534.52 C 1544.01,534.52 1546.52,536.668 1546.52,539.655 C 1546.52,542.537 1544.48,544.319 1540.6,545.891 C 1535.26,547.987 1531.95,550.398 1531.95,554.957 C 1531.95,559.306 1535.05,562.608 1539.87,563.394 L 1539.87,568.687 L 1543.12,568.687 L 1543.12,563.603 C 1546.26,563.499 1548.41,562.66 1549.93,561.769 L 1548.62,558.311 C 1547.52,558.94 1545.37,560.092 1542.02,560.092 C 1537.98,560.092 1536.46,557.681 1536.46,555.586 C 1536.46,552.861 1538.4,551.498 1542.96,549.612 C 1548.36,547.411 1551.08,544.686 1551.08,540.022 C 1551.08,535.882 1548.2,532.004 1542.8,531.113 L 1542.8,525.663 L 1539.5,525.663 Z",
    fill: "#555555",
    strokeLinejoin: "miter",
    stroke: "none",
    strokeWidth: 1,
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1586.36,480.31 L 1586.36,484.931 C 1583.7,484.977 1580.96,485.801 1579.36,486.945 L 1580.45,490.01 C 1582.1,488.912 1584.48,488.043 1587.04,488.043 C 1590.29,488.043 1592.49,489.919 1592.49,492.527 C 1592.49,495.043 1590.7,496.599 1587.32,497.972 C 1582.65,499.802 1579.77,501.907 1579.77,505.888 C 1579.77,509.685 1582.47,512.568 1586.68,513.255 L 1586.68,517.876 L 1589.52,517.876 L 1589.52,513.437 C 1592.26,513.346 1594.14,512.614 1595.46,511.836 L 1594.32,508.816 C 1593.36,509.365 1591.48,510.372 1588.56,510.372 C 1585.03,510.372 1583.7,508.267 1583.7,506.437 C 1583.7,504.058 1585.4,502.868 1589.38,501.221 C 1594.09,499.299 1596.47,496.919 1596.47,492.847 C 1596.47,489.232 1593.95,485.847 1589.24,485.069 L 1589.24,480.31 L 1586.36,480.31 Z",
    fill: "#555555",
    strokeLinejoin: "miter",
    stroke: "none",
    strokeWidth: 1,
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1611.01,464.84 C 1611.01,461.944 1608.64,459.576 1605.74,459.576 L 1570.09,459.576 C 1567.19,459.576 1564.82,461.944 1564.82,464.84 L 1564.82,528.004 C 1564.82,530.899 1567.19,533.268 1570.09,533.268 L 1605.74,533.268 C 1608.64,533.268 1611.01,530.899 1611.01,528.004 L 1611.01,464.84 Z",
    stroke: "#555555",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1603.31,472.141 L 1585.65,472.141 L 1572.52,472.141 L 1572.52,478.896 L 1572.52,523.306 L 1603.31,523.306 L 1603.31,472.141 Z",
    stroke: "#555555",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1563.69,505.526 L 1480.54,505.526 C 1476.22,505.526 1472.69,509.058 1472.69,513.375 L 1472.69,580.975 C 1472.69,585.292 1476.22,588.824 1480.54,588.824 L 1602.03,588.824 C 1606.34,588.824 1609.88,585.292 1609.88,580.975 L 1609.88,532.214",
    fill: "none",
    stroke: "#555555",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1563.69,517.202 L 1488.48,517.202 C 1486.14,517.202 1484.22,519.116 1484.22,521.454 L 1484.22,572.488 C 1484.22,574.826 1486.14,576.74 1488.48,576.74 L 1594.09,576.74 C 1596.43,576.74 1598.34,574.826 1598.34,572.488 L 1598.34,534.699",
    fill: "none",
    stroke: "#555555",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1559.97,495.253 L 1552.42,495.253 L 1552.42,505.526 L 1529.22,505.526 L 1529.22,495.253 L 1521.67,495.253 C 1513.24,495.253 1506.35,488.356 1506.35,479.925 L 1563.69,479.925 L 1563.69,494.792 C 1563.69,494.792 1561.25,495.253 1559.97,495.253 Z",
    stroke: "#555555",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1590.65,466.072 C 1590.65,464.56 1589.43,463.334 1587.91,463.334 C 1586.4,463.334 1585.18,464.56 1585.18,466.072 C 1585.18,467.585 1586.4,468.811 1587.91,468.811 C 1589.43,468.811 1590.65,467.585 1590.65,466.072 Z",
    fill: "#555555",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "miter",
    markerStart: "none",
    markerEnd: "none"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 3",
    transform: "scale(1 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortal);
export default __webpack_public_path__ + "static/media/portal.f94a3aae228938f62802e96fc96672d8.svg";
export { ForwardRef as ReactComponent };